import { contemberLinkToHref } from './contemberLinkToHref'
import type { LinkResult } from '../data/LinkFragment'

// Utility used ONLY by header components to prefix internal links with main domain.
export const headerLinkToHrefTargetRel = (link: LinkResult) => ({
	href:
		link.type === 'internal' && link.internalLink?.url
			? `https://www.almacareer.com${link.internalLink.url}`
			: contemberLinkToHref(link),
	target: link.isTargetBlank ? '_blank' : undefined,
	rel: link.isTargetBlank ? 'noreferrer' : undefined,
})
